import {
    Card,
    CardContent,
    Divider,
    Grid,
    InputLabel,
    MenuItem,
    TextField,
    Autocomplete,
    Container,
    Dialog,
    DialogTitle,
    IconButton,
    FormControl,
    Switch,
    FormControlLabel
} from '@mui/material'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'

BigInt.prototype.toJSON = function () {
    return this.toString()
}

function PlanDrawer({
    visible,
    okText,
    onSubmit,
    onCancel,
    title,
    initialValues,
    applicationData,
    modulesData,
    onApplicationChange,
    action = 'new'
}) {
    if (initialValues == undefined) {
        initialValues = {
            name: '',
            application_id: '',
            modules: [],
            free_users: '',
            fixed_charge: '',
            max_users: '',
            price_per_user: '',
            currency: '',
            plan_duration: '',
            expiry: '',
            plan_description: '',
            cgst: 0,
            sgst: 0,
            igst: 0,
            applicable_from: '',
            sku_limit: '',
            bill_limit: '',
            application: '',
            trial_plan: false
        }
        if (initialValues.application == undefined)
            initialValues.application = ''
    }

    if (applicationData == undefined) {
        applicationData = []
    }

    if (modulesData == undefined) {
        modulesData = []
    }

    let validationSchemaFormat;
    if (action == 'new') {
        validationSchemaFormat = Yup.object().shape({
            name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
            free_users: Yup.number().required('Required'),

            application_id: Yup.string().required('Required'),
            modules: Yup.array().of(
                Yup.object().shape({
                    _id: Yup.string().required('Required'),
                })
            ),
            max_users: Yup.number().required('Required'),
            fixed_charge: Yup.number().required('Required'),
            price_per_user: Yup.number().required('Required'),
            currency: Yup.string().required('Required'),
            plan_duration: Yup.string().required('Required'),
            plan_description: Yup.string().required('Required'),
            expiry: Yup.date().required('Required'),
            igst: Yup.number().required('Required'),
            applicable_from: Yup.date().required('Required'),
            sku_limit: Yup.number().required('Required'),
            bill_limit: Yup.number().required('Required'),
        })
    }
    else {
        validationSchemaFormat = Yup.object().shape({
            name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
            free_users: Yup.number().required('Required'),
            modules: Yup.array().of(
                Yup.object().shape({
                    _id: Yup.string().required('Required'),
                })
            ),
            max_users: Yup.number().required('Required'),
            fixed_charge: Yup.number().required('Required'),
            price_per_user: Yup.number().required('Required'),
            currency: Yup.string().required('Required'),
            plan_duration: Yup.string().required('Required'),
            plan_description: Yup.string().required('Required'),
            expiry: Yup.date().required('Required'),
            igst: Yup.number().required('Required'),
            applicable_from: Yup.date().required('Required'),
            sku_limit: Yup.number().required('Required'),
            bill_limit: Yup.number().required('Required'),
        })
    }
    const validationSchema = validationSchemaFormat

    const handleSubmit = (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    const handleChangeApplication = async (event) => {
        onApplicationChange(event.target.value)
    }

    return (
        <div>
            <Dialog
                maxWidth='sm'
                fullWidth
                anchor="right"
                backdrop="static"
                variant="temporary"
                open={visible}
            >
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onCancel}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                            touched,
                            values,
                            status,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Divider />
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={5} columns={15} >
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="name"
                                                    label="Name"
                                                    value={values.name}
                                                    error={Boolean(touched.name && errors.name)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <TextField
                                                    size="small"
                                                    name="fixed_charge"
                                                    label="Fixed Price"
                                                    value={values.fixed_charge}
                                                    error={Boolean(touched.fixed_charge && errors.fixed_charge)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="number"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <TextField
                                                    size="small"
                                                    name="price_per_user"
                                                    label="Price Per User"
                                                    value={values.price_per_user}
                                                    error={Boolean(touched.price_per_user && errors.price_per_user)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="number"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <TextField
                                                    size="small"
                                                    name="currency"
                                                    label="Currency"
                                                    value={values.currency}
                                                    error={Boolean(touched.currency && errors.currency)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                    select
                                                >
                                                    <MenuItem value="INR">
                                                        <em>INR</em>
                                                    </MenuItem>
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={6} sx={{ paddingTop: 3 }}>
                                            <Grid item md={6}>

                                                {action == 'new' ? <>

                                                    <TextField
                                                        size='small'
                                                        id="application_id"
                                                        label="Application"
                                                        name="application_id"
                                                        //required ={true}
                                                        value={values.application_id}
                                                        error={Boolean(touched.application_id && errors.application_id)}
                                                        fullWidth
                                                        onBlur={handleBlur}
                                                        margin="dense"
                                                        onChange={(event) => {
                                                            setFieldValue('application_id', event.target.value)
                                                            handleChangeApplication(event)
                                                        }}
                                                        variant="outlined"
                                                        select>

                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {applicationData.map((application) => (
                                                            <MenuItem dense key={application._id} value={application._id}>
                                                                {application.application_name}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </> : <TextField
                                                    name="application"
                                                    label="Application"
                                                    disabled
                                                    value={values?.application?.application_name}
                                                    error={Boolean(touched.application && errors.application)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />}
                                            </Grid>
                                            <Grid item md={6} >
                                                <FormControl fullWidth>
                                                    <InputLabel id="module_select" />
                                                    <Autocomplete
                                                        size='small'
                                                        multiple
                                                        id="modules_select"
                                                        name="modules"
                                                        options={modulesData}
                                                        getOptionLabel={(option) => option.module_name}
                                                        isOptionEqualToValue={(option, value) => option._id === value._id}
                                                        value={values.modules}
                                                        onChange={(e, value) => {
                                                            setFieldValue('modules', value)
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                label="Modules"
                                                                margin="dense"
                                                            />
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={6} sx={{ paddingTop: 3 }}>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    id="applicable_from"
                                                    label="Applicable From"
                                                    type="date"
                                                    value={values.applicable_from}
                                                    error={Boolean(touched.applicable_from && errors.applicable_from)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    id="expiry"
                                                    label="Expiry"
                                                    type="date"
                                                    value={values.expiry}
                                                    error={Boolean(touched.expiry && errors.expiry)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={6} sx={{ paddingTop: 3 }}>
                                            <Grid item md={4}>
                                                <TextField
                                                    size="small"
                                                    name="free_users"
                                                    label="Free Users"
                                                    value={values.free_users}
                                                    error={Boolean(touched.free_users && errors.free_users)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="number"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <TextField
                                                    size="small"
                                                    name="plan_duration"
                                                    label="Plan Duration"
                                                    value={values.plan_duration}
                                                    error={Boolean(touched.plan_duration && errors.plan_duration)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="number"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <TextField
                                                    size="small"
                                                    name="max_users"
                                                    label="Max Users"
                                                    value={values.max_users}
                                                    error={Boolean(touched.max_users && errors.max_users)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="number"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={6} sx={{ paddingTop: 3 }}>
                                            <Grid item md={4}>
                                                <TextField
                                                    size="small"
                                                    name="igst"
                                                    label="GST"
                                                    value={values.igst}
                                                    error={Boolean(touched.igst && errors.igst)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="number"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={4}>
                                                <TextField
                                                    size="small"
                                                    name="sku_limit"
                                                    label="SKU Limit"
                                                    value={values.sku_limit}
                                                    error={Boolean(touched.sku_limit && errors.sku_limit)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    type="number"
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>

                                            <Grid item md={4}>
                                                <TextField
                                                    size="small"
                                                    name="bill_limit"
                                                    label="Bill Limit"
                                                    value={values.bill_limit}
                                                    error={Boolean(touched.bill_limit && errors.bill_limit)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="number"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={6} sx={{ paddingTop: 3 }}>
                                            <Grid item md={12}>
                                                <TextField
                                                    name="plan_description"
                                                    label="Plan description"
                                                    value={values.plan_description}
                                                    error={Boolean(touched.plan_description && errors.plan_description)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    name="trial_plan"
                                                    onChange={handleChange}
                                                    checked={values.trial_plan}
                                                />
                                            }
                                            label="Trial Plan"
                                            labelPlacement="start"
                                        />
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item  >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </div >
    );
}

export default PlanDrawer;